import { Injectable } from '@angular/core';
import { Observable, delay, of } from 'rxjs';
import { NotificationSummaryResponse } from './responses/notification.responses';

// Mock data until the API exists.
@Injectable()
export class NotificationService {
  getSummary(): Observable<NotificationSummaryResponse> {
    const summary: NotificationSummaryResponse = {
      notificationCount: 3,
      messageCount: 2
    };
    return of(summary).pipe(delay(100));
    // When API is ready:
    // return this.http.get<NotificationSummaryResponse>(`${environment.apiUrl}/notifications/summary`);
  }
}
